module.exports = __webpack_public_path__ + "static/media/moment19.d5781838.jpg";